import { Link } from 'react-router';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Button from '@mui/joy/Button';
import Cancel from '@mui/icons-material/Cancel';
import { useQuery } from '@apollo/client';
import { GET_MY_SUBSCRIPTION } from '../../gql/subscription.queries';

export default function SubscriptionCancel() {

  const { data: subscriptionData } = useQuery(GET_MY_SUBSCRIPTION);
  const subscription = subscriptionData?.mySubscription;

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '60vh',
      p: 2
    }}>
      <Card sx={{ maxWidth: 500, textAlign: 'center' }}>
        <CardContent sx={{ gap: 3, alignItems: 'center' }}>
          <Cancel sx={{ fontSize: 80, color: 'warning.500' }} />

          <Box>
            <Typography level="h2" sx={{ mb: 1 }}>
              Checkout Cancelled
            </Typography>
            <Typography level="body-lg" color="neutral">
              You haven{"'"}t been charged. Your checkout session was cancelled.
            </Typography>
          </Box>

          <Typography level="body-md" color="neutral" sx={{ maxWidth: 400 }}>
            If you experienced any issues during checkout or have questions about our plans,
            please don{"'"}t hesitate to contact our support team.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              size="lg"
              component={Link}
              to={subscription ? "/settings/billing/plan" : "/select-plan"}
            >
              {subscription ? "View Plans" : "Select Plan"}
            </Button>
            {subscription && <Button
              size="lg"
              variant="outlined"
              component={Link}
              to="/dashboard"
            >
              Go to Dashboard
            </Button>
            }
          </Box>

          {/* <Typography level="body-sm" color="neutral">
            Need help?{' '}
            <Typography
              component="a"
              href="mailto:support@cavalryhr.com"
              sx={{ color: 'primary.500', textDecoration: 'none' }}
            >
              Contact Support
            </Typography>
          </Typography> */}
        </CardContent>
      </Card>
    </Box>
  );
}
